import React, { useContext, useEffect } from 'react';
import { withTheme } from '@rjsf/core';
import { Theme as SemanticUITheme } from '@rjsf/semantic-ui';
import { RJSFSchema, FieldTemplateProps } from '@rjsf/utils';
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import validator from '@rjsf/validator-ajv8';
//import { InitOptions } from '../../player/types/player';
//import Utils from '../../player/utils/Utils';
import { Context } from '../PlayerBuilderContext';
//import 'semantic-ui-css/semantic.min.css'
import Editor from './Editor';
let timeoutChange: any = null;

let borderStyle = {
    border: '3px solid #aaa',
}
let editorStyle = {
    width: '100%',
    height: 'calc(100% - 60px)',
    padding: '0px'
}

const FormRJSF = withTheme(SemanticUITheme);

function CustomFieldTemplate(props: FieldTemplateProps) {
    const { id, classNames, style, label, help, required, description, errors, children } = props;    
    let fieldsUsingCustomTemplate = [
        'root_initOptions_controls_settings',
        'root_initOptions_controls_progressBar',
        'root_initOptions_controls_hide',
        'root_initOptions_controls_hideList',
        'root_initOptions_controls_liveAutoHide',
        'root_initOptions_controls_topLeft',
        'root_initOptions_controls_topRight',
        'root_initOptions_controls_bottomLeft',
        'root_initOptions_controls_bottomRight',
        'root_initOptions_controls_subMenu',
        'root_initOptions_controls_middle',
        'root_initOptions_controls_specificDevices'
    ]
    if (fieldsUsingCustomTemplate.includes(id)) {
        return (
          <div className={classNames} style={style}>        
            <details>
                <summary>
                  {label}
                  {required ? '*' : null}
                </summary>                
                {children}
                {errors}
                {help}               
            </details>
          </div>
        );
    }
    return (
        <div className={classNames}>
            
            {children}
            {errors}
            {help}
        </div>
    )
  }

export default function Form(props: {
    onChange: any, onCss: any, onJs: any, onOptionsOverride: any
}) {
    
    const { onChange, onCss, onJs, onOptionsOverride } = props;

    const { formOptions, schema, css, js, optionsOverride }: any = useContext(Context);

    let afterControls = false;
    let forms: any = {
        basics: {
            initOptions: {}
        },
        controls: {
            initOptions: {}
        },
        advanced: {
            initOptions: {}
        }
    }; 

    let basics = ['source', 'fit', 'muted', 'poster', 'autoplay', 'controlsColor', 'bgColor', 'loop']

    for(var i in formOptions) {
        if(i === 'controls') {
            afterControls = true;            
            forms['controls']['initOptions'][i] = formOptions[i];
        }
        else {
            if(basics.indexOf(i) === -1) {
                forms['advanced']['initOptions'][i] = formOptions[i];
            }
            else {
                forms['basics']['initOptions'][i] = formOptions[i];                
            }
        }
    }

    let tmpSchema = JSON.parse(JSON.stringify(schema));
    for(var i in tmpSchema.properties) {
        if(i != 'initOptions') 
            delete tmpSchema.properties[i];
    }

    let schemas: any = {
        basics: JSON.parse(JSON.stringify(tmpSchema)),
        controls: JSON.parse(JSON.stringify(tmpSchema)),
        advanced: JSON.parse(JSON.stringify(tmpSchema))
    };
    
    for(var i in schemas.controls.definitions.initOptions.properties) {
        if(i != 'controls') {
            delete schemas.controls.definitions.initOptions.properties[i];
        }
    }
    delete schemas.controls.definitions.initOptions.required; 
    
    delete schemas.basics.definitions.source.properties.startTime;
    delete schemas.basics.definitions.source.properties.endTime;
    delete schemas.basics.definitions.source.properties.streamType;
    delete schemas.basics.definitions.source.properties.textTracks;
    delete schemas.basics.definitions.source.properties.playbackMode;
    delete schemas.basics.definitions.source.properties.sourceType;
    delete schemas.basics.definitions.source.properties.alternativeLanguageSources;
    
    for(var i in schemas.basics.definitions.initOptions.properties) {
        if(basics.indexOf(i) === -1) {
            delete schemas.basics.definitions.initOptions.properties[i];
        }
    }

    for(var i in basics) {        
        delete schemas.advanced.definitions.initOptions.properties[basics[i]];
    }
    delete schemas.advanced.definitions.initOptions.properties.controls;
    delete schemas.advanced.definitions.initOptions.required;
    delete schemas.advanced.definitions.initOptions.properties.css;
    delete schemas.advanced.definitions.initOptions.properties.js;
    
    delete schemas.advanced.definitions.initOptions.properties.onBeforeInit;
    delete schemas.advanced.definitions.initOptions.properties.providersOptions;
    delete schemas.advanced.definitions.initOptions.properties.shortcuts;
    
    const [formData, setFormData] = React.useState(forms);

    const [tab, setTab] = React.useState('basics');
    
    /*console.log('schema', schema);
    console.log('schemas', schemas);
    console.log('schemas forms', forms); 
    console.log('schemas formOptions', formOptions)*/

    /*let initOptions = JSON.parse(JSON.stringify(schema));

    delete initOptions.properties.source;
    delete initOptions.properties.controls;*/

    function onChangeFormData(tab: string, data: any) {
        console.log('onChangeFormData', tab, data);
        setFormData({
            ...formData,
            [tab]: {
                initOptions: data
            }
        });
    }

    
    useEffect(() => {
        //merge formData bascis, controls, advanced
        let data = {
            ...formData.basics.initOptions,
            ...formData.controls.initOptions,
            ...formData.advanced.initOptions
        };
        if(timeoutChange) {
            console.log('clear');
            clearTimeout(timeoutChange);
        }
        timeoutChange = setTimeout(() => {
            onChange(data);
        }, 500);
    }, [formData]);

    let urlParams = new URLSearchParams(window.location.search);
    let hasDeveloper= urlParams.get('developer');

    //we don't let define specificDevices in the form, you can do in the developper tab with optionsOverride !
    delete schemas.controls.definitions.controls.properties.specificDevices;

    return (
        <React.Fragment>
            <div className="ui pointing menu">
                <a className={"item " + (tab == 'basics' ? "active":"")} onClick={(e) => { setTab('basics')}}>Basics</a>
                <a className={"item " + (tab == 'controls' ? "active":"")} onClick={(e) => { setTab('controls')}}>Controls</a>
                { false &&
                    <a className={"item " + (tab == 'advanced' ? "active":"")} onClick={(e) => { setTab('advanced')}}>Advanced</a>
                }
                { true &&
                    <a className={"item " + (tab == 'developer' ? "active":"")} onClick={(e) => { setTab('developer')}}>Developer</a>
                }
            </div>
            { tab === 'basics' &&
                <div className="ui segment active tab">
                    <FormRJSF  
                        schema={schemas.basics as RJSFSchema} 
                        validator={validator} 
                        formData={formData.basics}
                        
                        onChange={({ formData }, e) => {                    
                            //onChange(formData.initOptions);
                            onChangeFormData('basics', formData.initOptions);
                        }}
                     />
                </div>
            }
            { tab === 'controls' &&
                <div className="ui segment active tab">
                    <FormRJSF  
                        schema={schemas.controls as RJSFSchema} 
                        validator={validator} 
                        formData={formData.controls}
                        templates={{ FieldTemplate: CustomFieldTemplate }}
                        onChange={({ formData }, e) => {                    
                            //onChange(formData.initOptions);
                            onChangeFormData('controls', formData.initOptions);
                        }}
                     />
                </div>
            }
            { tab === 'advanced' &&
                <div className="ui segment active tab">
                    <FormRJSF  
                        schema={schemas.advanced as RJSFSchema} 
                        validator={validator} 
                        formData={formData.advanced}

                        onChange={({ formData }, e) => {                    
                            //onChange(formData.initOptions);
                            onChangeFormData('advanced', formData.initOptions);
                        }}
                     />
                </div>
            }
            { tab === 'developer' &&
                <div className="ui segment active tab" style={ editorStyle }>
                    <PanelGroup direction="vertical">
                        <Panel maxSize={80} style={{ height: '100%' }}>
                            <Editor language="css" value={ css } readOnly={ false } 
                                onChange={(data: any) => {
                                    onCss(data);
                                }}
                            />
                        </Panel>
                        <PanelResizeHandle style={ borderStyle } />
                        <Panel maxSize={80} style={{ height: '100%' }}>
                            <Editor language="javascript" value={ js } readOnly={ false } 
                                onChange={(data: any) => {
                                    onJs(data);
                                }}
                            />
                        </Panel>
                        <PanelResizeHandle style={ borderStyle } />
                        <Panel maxSize={80} style={{ height: '100%' }}>
                            <Editor language="javascript" value={ optionsOverride } readOnly={ false } 
                                onChange={(data: any) => {
                                    onOptionsOverride(data);
                                }}
                            />
                        </Panel>
                    </PanelGroup>                
                </div>
            }
        </React.Fragment>
    );
}
